module.exports = __webpack_public_path__ + "static/media/IconDetailView.8eea836a.svg";